<h1 class="page-title">Edit My Account</h1>
<div
    class="warning-box"
    *ngIf="profile.reviewProfile"
>
    <img src="/assets/images/psd-warning-signsr-large.png">
    <p>
        Please review your profile information below and make any changes. After you have reviewed this information or made changes, choose Save to continue. You will only be asked to confirm your profile information once a year.
    </p>
</div>
<a
    style="font-size: larger;"
    href="#"
    routerLink="/practitioner/demographic/edit"
>
    My Demographics
</a>
<form
    [formGroup]="profileForm"
    (ngSubmit)="onSubmit(profileForm.value)"
>
    <div class="data-item">
        <div class="data-item__label label">Full Name</div>
        <div class="data-item__value">
            {{profile?.firstName}}
            <span *ngIf="profile?.middleName">{{profile?.middleName}}</span>
            {{profile?.lastName}}
            <span *ngIf="profile?.suffix">, {{profile?.suffix}}</span>
        </div>
    </div>
    <div class="data-item data-item--has-help-text">
        <div class="data-item__label-value-wrap">
            <div class="data-item__label label">SSN</div>
            <div class="data-item__value">
                XXX-XX-{{ profile?.ssn ? profile?.ssn.slice(-4) : 'XXXX'}}
            </div>
        </div>
        <p class="help-text data-item__help-text">
            NOTE: You cannot edit your name or social security number. If there is an error, please
            <a href="mailto:info@nbrc.org?subject=Name or SSN change">contact us</a>
            .
        </p>
    </div>
    <div class="form-row">
        <div class="field form-row__item">
            <div class="field__label-input-wrap">
                <label
                    for="birthday"
                    class="label"
                >
                    Date of Birth
                </label>
                <input
                    *ngIf="appSettings.IsCompatibilityMode === true"
                    class="input input--select-menu"
                    id="birthday"
                    name="birthday"
                    formControlName="birthday"
                    [class.input--invalid]="formErrors.birthday"
                    type="text"
                    mask="00/00/0000"
                >
                <input
                    *ngIf="appSettings.IsCompatibilityMode === false"
                    class="input input--select-menu"
                    id="birthday"
                    name="birthday"
                    formControlName="birthday"
                    [class.input--invalid]="formErrors.birthday"
                    type="date"
                >
                <div
                    *ngIf="formErrors.birthday"
                    class="error-message field__error-message"
                >
                    {{ formErrors.birthday }}
                </div>
            </div>
        </div>
        <div class="field form-row__item">
            <div class="field__label-input-wrap">
                <label
                    for="aarcNumber"
                    class="label"
                >
                    AARC Number
                    <span class="label__help-text">(optional)</span>
                </label>
                <input
                    class="input input--select-menu"
                    id="aarcNumber"
                    name="aarcNumber"
                    maxlength="10"
                    formControlName="aarcNumber"
                    [class.input--invalid]="formErrors.aarcNumber"
                    type="text"
                >
                <div
                    *ngIf="formErrors.aarcNumber"
                    class="error-message field__error-message"
                >
                    {{ formErrors.aarcNumber }}
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="field">
		<div class="field__label-input-wrap">
			<label for="gender" class="label">Gender</label>
			<select class="input input--select-menu" id="gender" name="gender" formControlName="gender" [class.input--invalid]="formErrors.gender">
				<option value="">Select One</option>
				<option value="F">Female</option>
				<option value="M">Male</option>
			</select>
			<div *ngIf="formErrors.gender" class="error-message field__error-message">{{ formErrors.gender }}</div>
		</div>
	</div> -->

    <div class="field-message-section">
        <div
            class="warning-box"
            *ngIf="badAddress"
        >
            <img src="/assets/images/psd-warning-signsr-large.png">
            <p>
                Our records indicate that your address may be outdated. Please review and correct if applicable.
            </p>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="country"
                    class="label"
                >
                    Country
                </label>
                <select
                    class="input input--select-menu input--large"
                    [class.input--invalid]="formErrors.countryId"
                    id="country"
                    formControlName="countryId"
                >
                    <option value>Select One</option>
                    <option
                        *ngFor="let c of countries"
                        [value]="c.id"
                    >
                        {{c.description}}
                    </option>
                </select>
                <div
                    *ngIf="formErrors.countryId"
                    class="error-message field__error-message"
                >
                    {{ formErrors.countryId }}
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="line1"
                    class="label"
                >
                    Address 1
                </label>
                <input
                    class="input  input--large"
                    id="line1"
                    formControlName="line1"
                    [class.input--invalid]="formErrors.line1"
                    uppercase
                >
                <div
                    *ngIf="formErrors.line1"
                    class="error-message field__error-message"
                >
                    {{ formErrors.line1 }}
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="line2"
                    class="label"
                >
                    Address 2
                    <span class="label__help-text">(optional)</span>
                </label>
                <input
                    class="input  input--large"
                    id="line2"
                    formControlName="line2"
                    [class.input--invalid]="formErrors.line2"
                    uppercase
                >
                <div
                    *ngIf="formErrors.line2"
                    class="error-message field__error-message"
                >
                    {{ formErrors.line2 }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-row">
        <div class="field form-row__item">
            <div class="field__label-input-wrap">
                <label
                    for="zip"
                    class="label"
                >
                    Zip&#x2F;Postal Code
                </label>
                <input
                    class="input"
                    id="zip"
                    formControlName="zip"
                    [class.input--invalid]="formErrors.zip"
                    [maxlength]="isUs ? 5: 10"
                    required
                    (blur)="performZipCodeLookup()"
                >
                <div
                    *ngIf="formErrors.zip"
                    class="error-message field__error-message"
                >
                    {{ formErrors.zip }}
                </div>
                <div
                    *ngIf="badZipMessage"
                    class="error-message field__error-message"
                >
                    The zip code you entered cannot be found.
					Please verify you correctly entered the zip code. If you require further assistance contact NBRC.
                </div>
            </div>
        </div>

        <div class="field form-row__item">
            <div class="field__label-input-wrap">
                <label
                    for="city"
                    class="label"
                >
                    City
                </label>
                <input
                    class="input  "
                    id="city"
                    formControlName="city"
                    [class.input--invalid]="formErrors.city"
                    uppercase
                >
                <div
                    *ngIf="formErrors.city"
                    class="error-message field__error-message"
                >
                    {{ formErrors.city }}
                </div>
            </div>
        </div>
        <div class="field form-row__item">
            <div class="field__label-input-wrap">
                <label
                    for="state"
                    class="label"
                >
                    State&#x2F;Province
                </label>
                <input
                    class="input"
                    id="stateProvince"
                    formControlName="stateProvince"
                    [maxlength]="isUs ? 2: 10"
                    [class.input--invalid]="formErrors.stateProvince"
                    uppercase
                >
                <div
                    *ngIf="formErrors.stateProvince"
                    class="error-message field__error-message"
                >
                    {{ formErrors.stateProvince }}
                </div>
            </div>
        </div>
    </div>
    <div class="form-row">
        <div class="field form-row__item">
            <div class="field__label-input-wrap">
                <label
                    for="homePhone"
                    class="label"
                >
                    Home Phone
                    <span class="label__help-text">(optional)</span>
                </label>
                <input
                    class="input"
                    id="homePhone"
                    formControlName="homePhone"
                    [class.input--invalid]="formErrors.homePhone"
                    type="tel"
                    mask="0*"
                    [dropSpecialCharacters]="true"
                >
                <div
                    *ngIf="formErrors.homePhone"
                    class="error-message field__error-message"
                >
                    {{ formErrors.homePhone }}
                </div>
            </div>
        </div>
        <div class="field form-row__item">
            <div class="field__label-input-wrap">
                <label
                    for="cellPhone"
                    class="label"
                >
                    Cell Phone
                </label>
                <input
                    class="input"
                    id="cellPhone"
                    formControlName="cellPhone"
                    [class.input--invalid]="formErrors.cellPhone"
                    type="tel"
                    mask="0*"
                    [dropSpecialCharacters]="true"
                >
                <div
                    *ngIf="formErrors.cellPhone"
                    class="error-message field__error-message"
                >
                    {{ formErrors.cellPhone }}
                </div>
            </div>
        </div>
    </div>

    <div
        class="warning-box"
        *ngIf="profile.badEmail"
    >
        <img src="/assets/images/psd-warning-signsr-large.png">
        <p>
            The email we last sent you was returned undeliverable. Please update your email address and communication preferences below. The email you enter will be used when you next login to the Practitioner Portal.
        </p>
    </div>

    <div class="field-message-section">
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="email"
                    class="label"
                >
                    Email
                </label>
                <input
                    class="input input--large"
                    id="email"
                    name="email"
                    type="email"
                    formControlName="email"
                    [class.input--invalid]="formErrors.email"
                >
                <div
                    *ngIf="formErrors.email"
                    class="error-message field__error-message"
                >
                    {{ formErrors.email }}
                </div>
            </div>
        </div>
        <h2 style="margin-top: 10px;">Communications Preference</h2>
        <h3>Go Paperless</h3>
        <div class="field">
            To reduce paper use, you have the option to receive annual payment notices electronically. 
			Check the box(s) below to receive an email and/or a text message in place of the mailed invoice when your annual 
			payment is due.
        </div>
        <p>
            <input
                class
                id="emailOptOut"
                formControlName="paperlessAnnualInvoiceOptIn"
                type="checkbox"
            >
            Electronic Annual Invoice
        </p>
        <p>
            <input
                class
                id="emailOptOut"
                formControlName="smsAnnualInvoiceOptIn"
                type="checkbox"
            >
            Text Message
        </p>
        <h3>Opt-Out</h3>
        <div class="field">
            Please select the communication you wish to opt-out of.
        </div>
        <div class="divAsRow">
            <div class="divAsColumn">
                <p>
                    <u>
                        <strong>Email</strong>
                    </u>
                </p>
                <p>
                    <input
                        class
                        id="emailOptOut"
                        formControlName="emailOptOutCredExp"
                        type="checkbox"
                    >
                    Credential Expiration
                </p>
                <p>
                    <input
                        class
                        id="emailOptOut"
                        formControlName="emailOptOutCMPAssessment"
                        type="checkbox"
                    >
                    CMP Assessments
                </p>
                <p>
                    <input
                        class
                        id="emailOptOut"
                        formControlName="emailOptOutAnnual"
                        type="checkbox"
                    >
                    Annual Payments
                </p>
                <p>
                    <input
                        class
                        id="emailOptOut"
                        formControlName="emailOptOutMarket"
                        type="checkbox"
                    >
                    Marketing and Promotions
                </p>
                <p>
                    <input
                        class
                        id="emailOptOut"
                        formControlName="emailOptOutResearch"
                        type="checkbox"
                    >
                    Research Studies
                </p>
                <p>
                    <input
                        class
                        id="emailOptOut"
                        formControlName="emailOptOut"
                        type="checkbox"
                    >
                    All Email*
                </p>
                <p style="font:smaller">
                    *We will only contact you about policy adjustments.
                </p>
            </div>
            <div class="column">
                <p>
                    <u>
                        <strong>Text</strong>
                    </u>
                </p>
                <p>
                    <input
                        class="input input--checkbox"
                        id="textOptIn"
                        formControlName="smscmpAssessmentsOptIn"
                        type="checkbox"
                    >
                    CMP Assessments
                </p>
                <p>
                    <input
                        class="input input--checkbox"
                        id="textOptIn"
                        formControlName="smsCredentialExpirationOptIn"
                        type="checkbox"
                    >
                    Credential Expiration
                </p>
            </div>
        </div>
        <p>
            <strong>
                <u>Other Options</u>
            </strong>
        </p>
        <div class="form-row">
            <div class="field field--inline">
                <input
                    class="input input--checkbox"
                    id="directoryOptOut"
                    formControlName="directoryOptOut"
                    type="checkbox"
                >
                <label
                    for="directoryOptOut"
                    class="label label--inline"
                >
                    I wish to exclude my name from the online verify credential search.
                </label>
            </div>
        </div>
        <div class="form-row">
            <div
                *ngIf="allowCmpOptInOrOut()"
                class="field field--inline"
            >
                <input
                    class="input input--checkbox"
                    id="cmpOptOut"
                    formControlName="cmpOptOut"
                    type="checkbox"
                >
                <label
                    for="cmpOptOut"
                    class="label label--inline  "
                >
                    I am opting out of the CMP.
                </label>
            </div>
        </div>
        <div
            *ngIf="!validFormCheck"
            class="error-message"
        >
            <div class="form-row">
                <p>Fix errors indicated above to continue.</p>
            </div>
        </div>
    </div>
    <div class="form-actions">
        <input
            class="button form-actions__item"
            type="submit"
            value="Save"
        >
        <button
            (click)="cancel($event)"
            class="button button--secondary form-actions__item"
        >
            Cancel
        </button>
    </div>
</form>
